import { render, staticRenderFns } from "./gLogin.vue?vue&type=template&id=3a15326a&scoped=true&"
import script from "./gLogin.vue?vue&type=script&lang=js&"
export * from "./gLogin.vue?vue&type=script&lang=js&"
import style0 from "./gLogin.vue?vue&type=style&index=0&id=3a15326a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15326a",
  null
  
)

export default component.exports